var _slicedToArray = require("C:/vagrant_tienda/apache/kinedu-educators-landing/node_modules/@babel/runtime/helpers/slicedToArray");

var _taggedTemplateLiteral = require("C:/vagrant_tienda/apache/kinedu-educators-landing/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject10, _templateObject11, _templateObject12, _templateObject13, _templateObject14, _templateObject15, _templateObject16, _templateObject17, _templateObject18, _templateObject19, _templateObject20, _templateObject21, _templateObject22, _templateObject23;

module.exports = function (e) {
  var t = {};

  function n(a) {
    if (t[a]) return t[a].exports;
    var r = t[a] = {
      i: a,
      l: !1,
      exports: {}
    };
    return e[a].call(r.exports, r, r.exports, n), r.l = !0, r.exports;
  }

  return n.m = e, n.c = t, n.d = function (e, t, a) {
    n.o(e, t) || Object.defineProperty(e, t, {
      enumerable: !0,
      get: a
    });
  }, n.r = function (e) {
    "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
      value: "Module"
    }), Object.defineProperty(e, "__esModule", {
      value: !0
    });
  }, n.t = function (e, t) {
    if (1 & t && (e = n(e)), 8 & t) return e;
    if (4 & t && "object" == typeof e && e && e.__esModule) return e;
    var a = Object.create(null);
    if (n.r(a), Object.defineProperty(a, "default", {
      enumerable: !0,
      value: e
    }), 2 & t && "string" != typeof e) for (var r in e) {
      n.d(a, r, function (t) {
        return e[t];
      }.bind(null, r));
    }
    return a;
  }, n.n = function (e) {
    var t = e && e.__esModule ? function () {
      return e.default;
    } : function () {
      return e;
    };
    return n.d(t, "a", t), t;
  }, n.o = function (e, t) {
    return Object.prototype.hasOwnProperty.call(e, t);
  }, n.p = "", n(n.s = 62);
}({
  1: function _(e, t) {
    e.exports = require("react");
  },
  10: function _(e, t) {
    e.exports = require("../../styles/breakpoints");
  },
  2: function _(e, t) {
    e.exports = require("styled-components");
  },
  3: function _(e, t) {
    e.exports = require("../../styles");
  },
  5: function _(e, t) {
    e.exports = require("../Icon/Icon");
  },
  62: function _(e, t, n) {
    "use strict";

    var a = this && this.__importStar || function (e) {
      if (e && e.__esModule) return e;
      var t = {};
      if (null != e) for (var n in e) {
        Object.hasOwnProperty.call(e, n) && (t[n] = e[n]);
      }
      return t.default = e, t;
    },
        r = this && this.__importDefault || function (e) {
      return e && e.__esModule ? e : {
        default: e
      };
    };

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var i = a(n(1)),
        l = a(n(2)),
        o = n(3),
        d = r(n(5)),
        u = r(n(10)),
        s = o.colorPalettes.KineduPalette,
        c = l.default.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n\n  ", "\n"])), function (_ref) {
      var e = _ref.isMenuOpen;
      return e && l.css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n      overflow: hidden;\n    "])));
    }),
        f = l.default.div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  display: flex;\n  flex: 1;\n  height: 100%;\n"]))),
        p = l.default.div(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  width: 0px;\n  height: 100%;\n  background-color: ", ";\n  box-shadow: 10px 0px 7px -8px rgba(0, 0, 0, 0.2);\n  overflow: auto;\n  z-index: 999999;\n  position: fixed;\n\n  @keyframes entering {\n    0% {\n      width: 0px;\n      transform: translateX(-256px);\n    }\n    1% {\n      width: 256px;\n    }\n    100% {\n      width: 256px;\n      transform: translateX(0px);\n    }\n  }\n\n  @keyframes leaving {\n    0% {\n      width: 256px;\n      transform: translateX(0px);\n    }\n    99% {\n      width: 256px;\n      transform: translateX(-256px);\n    }\n    100% {\n      width: 0px;\n    }\n  }\n\n  ", "\n"])), s.shadeLighter, function (_ref2) {
      var e = _ref2.show,
          t = _ref2.control;
      return e ? l.css(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n        animation: entering 0.5s 1 forwards;\n\n        ", " {\n          animation: none;\n          /* animation: entering 0s 1 forwards; */\n          width: 256px;\n        }\n      "])), u.default.largeTablet) : !e && t ? l.css(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n        animation: leaving 0.5s 1 forwards;\n\n        ", " {\n          animation: none;\n          /* animation: leaving 0s 1 forwards; */\n          width: 0px;\n        }\n      "])), u.default.largeTablet) : l.css(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n      animation: leaving 0.5s 1 forwards;\n      ", " {\n        animation: none;\n        width: 256px;\n      }\n    "])), u.default.largeTablet);
    }),
        h = l.default.div(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n  background-color: white;\n  cursor: default;\n"]))),
        m = l.default.div(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  padding: 10px 20px;\n"]))),
        x = l.default.div(_templateObject10 || (_templateObject10 = _taggedTemplateLiteral(["\n  flex-shrink: 0;\n  width: 40px;\n  height: 40px;\n  background: ", ";\n  border-radius: 100px;\n  margin-right: 10px;\n"])), s.shadeMediumLight),
        g = l.default.span(_templateObject11 || (_templateObject11 = _taggedTemplateLiteral(["\n  font-size: 18px;\n  font-weight: bold;\n  color: ", ";\n  letter-spacing: -0.5px;\n  line-height: 24px;\n  text-overflow: ellipsis;\n  overflow: hidden;\n"])), s.shadeDarker),
        b = l.default.div(_templateObject12 || (_templateObject12 = _taggedTemplateLiteral(["\n  background-color: ", ";\n"])), s.shadeLight),
        v = l.default.div(_templateObject13 || (_templateObject13 = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  height: 70px;\n  padding: 0 20px;\n\n  border-bottom: 1px solid ", ";\n\n  font-size: 14px;\n  color: ", ";\n  text-transform: uppercase;\n  letter-spacing: 3px;\n  cursor: pointer;\n\n  :hover {\n    background-color: rgba(0, 0, 0, 0.05);\n  }\n\n  svg {\n    * {\n      fill: ", ";\n    }\n    margin-right: 5px;\n  }\n\n  ", "\n"])), s.shadeMediumLight, s.kineduShade, s.kineduShade, function (_ref3) {
      var e = _ref3.active;
      return e && l.css(_templateObject14 || (_templateObject14 = _taggedTemplateLiteral(["\n      color: white;\n      background-color: ", ";\n\n      :hover {\n        background-color: ", ";\n      }\n\n      svg {\n        * {\n          fill: white;\n        }\n      }\n    "])), s.kineduShade, s.kineduShade);
    }),
        w = l.default.span(_templateObject15 || (_templateObject15 = _taggedTemplateLiteral([""]))),
        y = l.default.div(_templateObject16 || (_templateObject16 = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  padding: 0 10px;\n\n  height: 60px;\n  background-color: white;\n\n  .menu-icon-burger {\n    z-index: 1;\n  }\n\n  ", " {\n    display: none;\n  }\n"])), u.default.largeTablet),
        k = l.default.div(_templateObject17 || (_templateObject17 = _taggedTemplateLiteral(["\n  /* position: absolute; */\n  width: 100%;\n\n  ", "\n\n  ", " {\n    position: relative;\n    width: auto;\n    flex: 1;\n    overflow: auto;\n    margin-left: 256px;\n\n    ", "\n  }\n"])), function (_ref4) {
      var e = _ref4.isMenuOpen;
      return e && l.css(_templateObject18 || (_templateObject18 = _taggedTemplateLiteral(["\n      height: calc(100% - 60px);\n      overflow: hidden;\n    "])));
    }, u.default.largeTablet, function (_ref5) {
      var e = _ref5.isMenuOpen;
      return e && l.css(_templateObject19 || (_templateObject19 = _taggedTemplateLiteral([""])));
    }),
        $ = l.default.div(_templateObject20 || (_templateObject20 = _taggedTemplateLiteral(["\n  display: none;\n  justify-content: center;\n  align-items: center;\n  width: 30px;\n  height: 30px;\n  margin-left: auto;\n  border-radius: 100px;\n  background-color: ", ";\n\n  ", "\n"])), s.kineduShade, function (_ref6) {
      var e = _ref6.show;
      return e && l.css(_templateObject21 || (_templateObject21 = _taggedTemplateLiteral(["\n      display: flex;\n    "])));
    }),
        E = l.default.div(_templateObject22 || (_templateObject22 = _taggedTemplateLiteral(["\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  opacity: 0;\n  background-color: rgba(0, 0, 0, 0.2);\n  transition: 0.5s all ease;\n  pointer-events: none;\n  z-index: 99;\n\n  ", "\n\n  ", " {\n    display: none;\n  }\n"])), function (_ref7) {
      var e = _ref7.isMenuOpen;
      return e && l.css(_templateObject23 || (_templateObject23 = _taggedTemplateLiteral(["\n      opacity: 1;\n      pointer-events: all;\n    "])));
    }, u.default.largeTablet),
        M = function M(_ref8) {
      var e = _ref8.show,
          _ref8$appName = _ref8.appName,
          t = _ref8$appName === void 0 ? "Menu name" : _ref8$appName,
          n = _ref8.items,
          a = _ref8.activeRoute,
          _ref8$showEditButton = _ref8.showEditButton,
          r = _ref8$showEditButton === void 0 ? !0 : _ref8$showEditButton,
          _ref8$showAvatar = _ref8.showAvatar,
          l = _ref8$showAvatar === void 0 ? !1 : _ref8$showAvatar,
          _ref8$closeWhenNaviga = _ref8.closeWhenNavigate,
          o = _ref8$closeWhenNaviga === void 0 ? !0 : _ref8$closeWhenNaviga,
          _ref8$beforeListRende = _ref8.beforeListRender,
          u = _ref8$beforeListRende === void 0 ? function () {} : _ref8$beforeListRende,
          _ref8$afterListRender = _ref8.afterListRender,
          s = _ref8$afterListRender === void 0 ? function () {} : _ref8$afterListRender,
          _ref8$onItemClicked = _ref8.onItemClicked,
          M = _ref8$onItemClicked === void 0 ? function () {} : _ref8$onItemClicked,
          _ref8$onEditClicked = _ref8.onEditClicked,
          O = _ref8$onEditClicked === void 0 ? function () {} : _ref8$onEditClicked,
          _ref8$content = _ref8.content,
          _ = _ref8$content === void 0 ? function () {} : _ref8$content;

      var _i$useState = i.useState(!1),
          _i$useState2 = _slicedToArray(_i$useState, 2),
          S = _i$useState2[0],
          j = _i$useState2[1],
          _i$useState3 = i.useState(e),
          _i$useState4 = _slicedToArray(_i$useState3, 2),
          P = _i$useState4[0],
          z = _i$useState4[1],
          T = function T() {
        return z(!P);
      },
          C = function C() {
        P && o && z && z(!1);
      };

      return i.useEffect(function () {
        z(e), e && j(!0);
      }, [e]), i.default.createElement(c, {
        isMenuOpen: P,
        className: "menu"
      }, i.default.createElement(y, {
        className: "menu-topbar"
      }, i.default.createElement(d.default, {
        name: "burger",
        className: "menu-icon-burger",
        size: 26,
        onClick: T
      })), i.default.createElement(f, {
        className: "menu-wrapper"
      }, i.default.createElement(p, {
        show: P,
        control: S
      }, i.default.createElement(h, null, i.default.createElement(m, null, l && i.default.createElement(x, null), i.default.createElement(g, null, t), i.default.createElement($, {
        onClick: function onClick() {
          O && O(), C();
        },
        show: r
      }, i.default.createElement(d.default, {
        size: 32,
        name: "edit",
        color: "white"
      })))), u(), i.default.createElement(b, null, n.map(function (e, t) {
        return i.default.createElement(v, {
          key: t,
          active: a === e.route,
          onClick: function onClick() {
            C(), M(e);
          }
        }, i.default.createElement(d.default, {
          name: e.icon,
          size: 32
        }), i.default.createElement(w, null, e.title));
      })), s()), i.default.createElement(k, {
        isMenuOpen: P
      }, i.default.createElement(E, {
        onClick: T,
        isMenuOpen: P
      }), _())));
    };

    M.defaultProps = {}, t.default = M;
  }
});